import WebsiteUrlModalComponent from './website-url-modal.component'

const WebsiteUrlModalModule = angular
  .module('cdbl.workroom.project-info.website-url-modal', [])
  .component('cdblWebsiteUrlModal', WebsiteUrlModalComponent)
  .name

export default WebsiteUrlModalModule
